




































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { JinroGameDocument, JinroPlayerDocument } from "@/services/datatypes";
import { collectionName } from "@/services/collection-name";
import { db } from "@/scripts/firebase";
import EachPlayerNameList from "@/components/JinroPlayer/EachPlayerNameList/EachPlayerNameList.vue";
import RuleInfo from "@/components/JinroPlayer/RuleInfo.vue";
import JinroGameChat from "@/components//JinroPlayer/JinroGameChat.vue";
import Gm from "@/components/JinroPlayer/Gm/Gm.vue";
import RoleInfo from "@/components/JinroPlayer/RoleInfo.vue";
import SoundEffect from "@/components/shared/SoundEffect.vue";

@Component({
  components: {
    EachPlayerNameList,
    RoleInfo,
    RuleInfo,
    JinroGameChat,
    Gm,
    SoundEffect,
  },
})
export default class JinroGame extends Vue {
  @Prop() readonly jinroGameId!: string;
  jinroGame: JinroGameDocument | null = null;
  detacher?: firebase.Unsubscribe;
  activeTab = 2;

  get isNextPlayQueueProcessing(): boolean {
    if (!this.jinroGame || !this.jinroGame.isNextPlayQueueProcessing) {
      return false;
    }
    return this.jinroGame.isNextPlayQueueProcessing;
  }

  get survivors(): Array<JinroPlayerDocument> {
    if (this.jinroGame) {
      return this.jinroGame.survivors;
    }
    return [];
  }

  get killedPlayers(): Array<JinroPlayerDocument> {
    if (this.jinroGame) {
      return this.jinroGame.killedPlayers;
    }
    return [];
  }

  @Watch("jinroGameId")
  onChange() {
    this.onSnapJinroGame();
  }

  async created() {
    await this.onSnapJinroGame();
  }

  destroyed() {
    this.detacher && this.detacher();
  }

  onSnapJinroGame() {
    this.detacher = this.refJinroGame.onSnapshot((snapshot) => {
      this.jinroGame = snapshot.data() as JinroGameDocument;
      this.$store.commit("setJinroGame", {
        id: this.jinroGameId,
        ...this.jinroGame,
      });
    });
  }

  get refJinroGame(): firebase.firestore.DocumentReference {
    return db.collection(collectionName.jinrogames).doc(this.jinroGameId);
  }
}
